var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.page === 'home')?_c('HomePage'):(_vm.page === 'taskblock')?_c('TaskBlockPage',{attrs:{"sub":_vm.sub}}):(_vm.page === 'admin')?_c('AdminPage'):(_vm.page === 'legal')?_c('LegalPage',{attrs:{"type":_vm.sub || 'privacy'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }